import { useMemo, useCallback, useContext } from 'react'

import { Box } from '@material-ui/core'
import { Selectors } from '@scoir/college-search'

import ContentModalContext from '../../ContentModalProvider/Context'
import { FIELD_NAMES } from '../../components/constants'
import tagService from 'common/tags-service'

const { API_CALL_NAMES, StudentLifeSelector, SelectorContextProvider } = Selectors
const fieldName = FIELD_NAMES.TAGS

const Categories = () => {
  const { item, onUpdateField, setSelectedCategories } = useContext(ContentModalContext)

  const value = useMemo(() => item[fieldName] || [], [item])

  const onSelect = useCallback(
    (data) => {
      const newVal = data[fieldName] || []
      onUpdateField(fieldName, newVal)
      setSelectedCategories(newVal)
    },
    [onUpdateField, setSelectedCategories],
  )

  return (
    <Box
      position="relative"
      zIndex={2}
    >
      <SelectorContextProvider
        apiCalls={{
          [API_CALL_NAMES.onTagsSearch]: tagService.fetchMediaByTerm,
          [API_CALL_NAMES.onAllTagsSearch]: tagService.getAllTags,
        }}
        data={{ [fieldName]: value }}
        onUpdateData={onSelect}
      >
        <StudentLifeSelector />
      </SelectorContextProvider>
    </Box>
  )
}

export default Categories
